<div (mouseleave)="closeActionPopUp()" class="actions-details" [hidden]="!displayActionPopUp" [ngStyle]="{'left': mouseClientX,'top': mouseClientY_Top,'bottom': mouseClientY_Bottom}"
    #outstandingPopup>
    <div class="inline-block float-right absolute-right">
        <button mat-icon-button (click)="closeActionPopUp()">
            <mat-icon aria-label="close">close</mat-icon>
        </button>
    </div>
    <table class="table">
        <thead>
            <tr>
                <th>{{Translate('Recommendation')}}</th>
                <th>{{Translate('Status')}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let act of actionStatusTable">
                <td>{{Translate(act.ActionTitle)}}</td>
                <td><span [ngClass]="act.CssClass">{{Translate(act.ActionStatus)}}</span></td>
            </tr>
        </tbody>
    </table>
</div>
<div (mouseleave)="closetrackPopUp()" class="track-details" [hidden]="!displaytrackPopUp" [ngStyle]="{'left': mouseClientX,'top': mouseClientY_Top,'bottom': mouseClientY_Bottom}"
    #outstandingPopup_>
    <div class="inline-block float-right absolute-right">
        <button mat-icon-button (click)="closetrackPopUp()">
            <mat-icon aria-label="close">close</mat-icon>
        </button>
    </div>
    <table class="table">
        <thead>
            <tr>
                <th>{{Translate('Position')}}</th>
                <th>{{Translate('Type')}}</th>
                <th>{{Translate('Track Roller Values - ')}} {{Translate(side_eval) }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let track of  trackPosition;  let i = index">
                <td >{{Translate(track.Position) }}</td>
                <td >{{Translate(track.Compart.CompartTitle) }}</td>
                <td class="component-span top {{getComponentTrackClass(track.Eval)}}">{{Translate(track.Worn) }}%</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="panel__content no-padding fleet-overview-table">
    <div *ngIf="equipmentDataLoading || _loading != 0" [class.loading-initial]="equipmentDataLoading"
        [class.loading-next-page]="_loading != 0">
        <mat-spinner></mat-spinner>
    </div>
   
    <mat-table *ngIf="!equipmentDataLoading && _loading == 0 && enableTab" class="table-material table-material-scroll table-material--striped table-material--hover table-material--full-width"
        #componentTable [dataSource]="componentViewDataSource" matSort (matSortChange)="sortChanged($event)"
        [@fadeInOut] [matSortActive]="_currentSort.active" matSortDisableClear [matSortDirection]="_currentSort.direction">
        <ng-container matColumnDef="Serial">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Serial')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row"  matTooltip="{{row.Equipment.Serial}}">
                <div class="SerialAndUnitText">{{row.Equipment.Serial}}</div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Unit">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Unit')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row"  matTooltip="{{row.Equipment.Unit}}">
                <div class="SerialAndUnitText">{{row.Equipment.Unit}}</div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="AddiUnit">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Additional Unit')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row"  matTooltip="{{row.Equipment.AddiUnit}}">
                <div class="SerialAndUnitText">{{row.Equipment.AddiUnit}}</div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Model">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Model')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.Equipment.MakeModelFamily.Model.Title}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Site">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Site')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="cell--jobsite"  matTooltip="{{row.Equipment.JobSite.Title}}">
                <div class="SerialAndUnitText"> {{row.Equipment.JobSite.Title}} </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="inspector">
            <mat-header-cell mat-sort-header  *matHeaderCellDef>{{ Translate('Inspector')}}  </mat-header-cell>
            <mat-cell *matCellDef="let row"  matTooltip="{{row.LastInspection.Inspector}}">  <div class="InspectorName">{{row.LastInspection.Inspector}}</div> </mat-cell>
        </ng-container>

        <ng-container matColumnDef="CurrentSMU">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Current SMU/Hourmeter')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center"> {{row.Equipment.SMU}} </mat-cell>
        </ng-container>
        <!-- <ng-container matColumnDef="LastInspectionDate">
            <mat-header-cell class="eval-header"  *matHeaderCellDef> {{Translate('Last Inspection Date')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="cell--date">
                <span *ngIf="row.LastInspection.Date == '0001-01-01T00:00:00'">N/A</span>
                <span *ngIf="row.LastInspection.Date != '0001-01-01T00:00:00'" >
                    {{row.LastInspection.Date | date:'dd-MMM-yyyy'}}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="LastInspectionSMU">
            <mat-header-cell class="eval-header"  *matHeaderCellDef> {{Translate('Last Inspection SMU/Hourmeter')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center"> {{row.LastInspection.SMU}} </mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="LastInspectionDate">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Last Inspection Date SMU/Hourmeter')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center">
                <span *ngIf="row.LastInspection.Date == '0001-01-01T00:00:00'">N/A</span>
                <span *ngIf="row.LastInspection.Date != '0001-01-01T00:00:00'" >{{(row.LastInspection.Date  | date : 'dd-MMM-yyyy')}} / {{row.LastInspection.SMU}}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NextInspectionSMU">
            <mat-header-cell mat-sort-header class="eval-header"  *matHeaderCellDef> {{Translate('Next Inspection Date SMU/Hourmeter')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="text-center">
                <span *ngIf="row.Equipment.NextInspectionDate == '1900-01-01T00:00:00'">-</span>
                <span *ngIf="row.Equipment.NextInspectionDate != '1900-01-01T00:00:00'" class="component-span top {{getNextInspectionCSSClass(row.Equipment.NextInspectionDate)}}">{{(row.Equipment.NextInspectionDate
                    | date : 'dd-MMM-yyyy')}}/{{row.Equipment.NextInspectionSMU}}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sides">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(0,1, row.Components)}}">
                    {{Translate('Left')}}
                </span>
                <span class="component-span bottom {{getComponentClass(0,2, row.Components)}}">
                    {{Translate('Right')}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Link">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Link')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(1,1, row.Components)}}">
                    {{getComponentValue(1,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(1,2, row.Components)}}">
                    {{getComponentValue(1,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="HoursOnLink">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Hours on Link')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(2,1, row.Components)}}">
                    {{getComponentValue(2,1, row.Components,row)}} {{Translate('hrs')}}
                </span>
                <span class="component-span bottom {{getComponentClass(2,2, row.Components)}}">
                    {{getComponentValue(2,2, row.Components,row)}} {{Translate('hrs')}}
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="TrackElon">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Track Elongation')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(16,1, row.Components)}}">
                    {{getComponentValue(16,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(16,2, row.Components)}}">
                    {{getComponentValue(16,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Bush">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Bush')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(3,1, row.Components)}}">
                    {{getComponentValue(3,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(3,2, row.Components)}}">
                    {{getComponentValue(3,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        

        <ng-container matColumnDef="BushTurnedBudget">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Bush Turned Budget')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getbudgetLifeClass(15,1, row.Components)}}">
                    {{getComponentValue(15,1, row.Components,row)}}
                </span>
                <span class="component-span bottom {{getbudgetLifeClass(15,2, row.Components)}}">
                    {{getComponentValue(15,2, row.Components,row)}}
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="BushTurned">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Bush Turned')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(4,1, row.Components)}}">
                    {{getComponentValue(4,1, row.Components,row)}}
                </span>
                <span class="component-span bottom {{getComponentClass(4,2, row.Components)}}">
                    {{getComponentValue(4,2, row.Components,row)}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Shoe">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Shoe')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(5,1, row.Components)}}">
                    {{getComponentValue(5,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(5,2, row.Components)}}">
                    {{getComponentValue(5,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="FrontIdler">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Front Idler')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(6,1, row.Components)}}">
                    {{getComponentValue(6,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(6,2, row.Components)}}">
                    {{getComponentValue(6,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="RearIdler">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Rear Idler')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(7,1, row.Components)}}">
                    {{getComponentValue(7,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(7,2, row.Components)}}">
                    {{getComponentValue(7,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Sprocket">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Sprocket')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(8,1, row.Components)}}">
                    {{getComponentValue(8,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(8,2, row.Components)}}">
                    {{getComponentValue(8,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CarrierRollerAVG">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Carrier Roller AVG')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(9,1, row.Components)}}">
                    {{getComponentValue(9,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(9,2, row.Components)}}">
                    {{getComponentValue(9,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CarrierRoller">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Carrier Rollers')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(14,1, row.Components)}}">
                    {{getComponentValue(14,1, row.Components,row)}}
                </span>
                <span class="component-span bottom {{getComponentClass(14,2, row.Components)}}">
                    {{getComponentValue(14,2, row.Components,row)}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRollerAVG">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Track Roller AVG')}} </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span #actionsPopUp_ class="component-span top {{getComponentClass(10,1, row.Components)}}" (mouseenter)="mouseOverTrackRollers($event, row,1)"
                (mouseleave)="mouseleaveTrackRollers()" >
                    {{getComponentValue(10,1, row.Components,row)}}%
                </span>
                <span #actionsPopUp_ class="component-span bottom {{getComponentClass(10,2, row.Components)}}"
                (mouseenter)="mouseOverTrackRollers($event, row,2)"
                (mouseleave)="mouseleaveTrackRollers()" >
                    {{getComponentValue(10,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRollerWorst">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Track Roller Worst')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(11,1, row.Components)}}">
                    {{getComponentValue(11,1, row.Components,row)}}%
                </span>
                <span class="component-span bottom {{getComponentClass(11,2, row.Components)}}">
                    {{getComponentValue(11,2, row.Components,row)}}%
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TrackRoller">
            <mat-header-cell class="eval-header" *matHeaderCellDef> {{Translate('Track Rollers')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span class="component-span top {{getComponentClass(13,1, row.Components)}}">
                    {{getComponentValue(13,1, row.Components,row)}}
                </span>
                <span class="component-span bottom {{getComponentClass(13,2, row.Components)}}">
                    {{getComponentValue(13,2, row.Components,row)}}
                </span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="OutstandingActions">
            <mat-header-cell  class="eval-header" *matHeaderCellDef> {{Translate('Outstanding Actions')}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="no-padding">
                <span #actionsPopUp class="component-span top {{getComponentClass(12,1, row.Components)}}" (mouseenter)="mouseOverAction($event, row,1)"
                (mouseleave)="mouseleaverAction()">
                    {{getOutstandingActions(1, row.Components, row.LastInspection.RecommendedActions)}}
                </span>
                <span #actionsPopUp class="component-span bottom {{getComponentClass(12,2, row.Components)}}" (mouseenter)="mouseOverAction($event, row,2)"
                (mouseleave)="mouseleaverAction()">
                    {{getOutstandingActions(2, row.Components, row.LastInspection.RecommendedActions)}}
                </span>
            </mat-cell>
        </ng-container>
        <!--<ng-container matColumnDef="openInNewTab">
            <mat-header-cell class="hover-new-tab__header ignore-click" *matHeaderCellDef></mat-header-cell>
            <mat-cell class="hover-new-tab__cell ignore-click overflow-hidden" *matCellDef="let row">
                <div class="expand-on-hover__element">
                    <button mat-icon-button (click)="openEquipmentNewTab($event, row.Id)" class="ignore-click new-tab-button" matTooltip="Open in new tab">
                        <mat-icon aria-label="Open in new tab" class="ignore-click">open_in_new</mat-icon>
                    </button>
                </div>
            </mat-cell>
        </ng-container>-->
        <mat-header-row *matHeaderRowDef="componentDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: componentDisplayedColumns;" class="hand-pointer expand-on-hover" (click)="rowClicked(row)"></mat-row>
    </mat-table>
    <mat-paginator [hidden]="!(!equipmentDataLoading && _loading == 0 && enableTab)" #componentPaginator [pageSize]="loadSize" [pageSizeOptions]="[5, 10, 25, 100]"
     (page)="componentPageChanged($event)">
  </mat-paginator>
</div>
